module.exports = __webpack_public_path__ + "img/5_windAndRain_cxy.f675685f.png";